// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plan-intermediate-stops.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plan-intermediate-stops/flight-plan-intermediate-stops.js';

mount([g0]);
